import { format, formatDistanceToNow, isToday, isYesterday, parseISO } from 'date-fns';
import { zhCN } from 'date-fns/locale';

/**
 * 解析 ISO 日期字符串，自动处理时区：
 * - 后端使用 datetime.utcnow() 存储 UTC 时间，isoformat() 输出无时区标记
 * - 若字符串不含时区信息（无 Z / +00:00 / 偏移量），自动追加 Z 视为 UTC
 * - date-fns 的 parseISO 会将带 Z 的时间正确转换为本地时间
 */
function parseDateAuto(dateStr: string): Date {
  if (!dateStr) return new Date();
  // 已有时区标记：Z 结尾、+HH:MM 偏移、-HH:MM 偏移
  const hasTimezone = /Z$|[+-]\d{2}:\d{2}$/.test(dateStr);
  return hasTimezone ? parseISO(dateStr) : parseISO(dateStr + 'Z');
}

export function formatDate(dateStr: string): string {
  const date = parseDateAuto(dateStr);
  if (isToday(date)) return `今天 ${format(date, 'HH:mm')}`;
  if (isYesterday(date)) return `昨天 ${format(date, 'HH:mm')}`;
  return format(date, 'yyyy-MM-dd HH:mm');
}

export function formatRelative(dateStr: string): string {
  return formatDistanceToNow(parseDateAuto(dateStr), { addSuffix: true, locale: zhCN });
}

export function formatShortDate(dateStr: string): string {
  return format(parseDateAuto(dateStr), 'MM-dd');
}

export function formatCredits(amount: number): string {
  if (amount >= 10000) return `${(amount / 10000).toFixed(1)}万`;
  return amount.toLocaleString('zh-CN');
}

export function formatPrice(cents: number): string {
  return `¥${(cents / 100).toFixed(2)}`;
}

export function formatPriceYuan(yuan: number): string {
  return `¥${yuan}`;
}

export function formatPercent(value: number): string {
  const sign = value > 0 ? '+' : '';
  return `${sign}${value.toFixed(1)}%`;
}

export function truncate(str: string, maxLen: number): string {
  if (str.length <= maxLen) return str;
  return `${str.slice(0, maxLen)}...`;
}
